import classNames from 'classnames'
import React from 'react'

import { AlertProps } from './Alert.types.ts'

const Alert: React.FC<AlertProps> = ({
  type,
  message,
  title,
  icon,
  fullWidth = false,
  className = ''
}) => {
  // Changed to full border and lighter background
  const baseClasses =
    'flex items-start gap-4 p-4 border rounded transition'

  const typeClasses = {
    success:
      'bg-green-50 border-green-400 text-green-800 dark:bg-opacity-25 dark:bg-green-900 dark:border-green-400 dark:text-green-200',
    warning:
      'bg-yellow-50 border-yellow-400 text-yellow-800 dark:bg-opacity-25 dark:bg-yellow-900 dark:border-yellow-400 dark:text-yellow-200',
    danger:
      'bg-red-50 border-red-400 text-red-800 dark:bg-opacity-25 dark:bg-red-900 dark:border-red-400 dark:text-red-200',
    info:
      'bg-blue-50 border-blue-400 text-blue-800 dark:bg-opacity-25 dark:bg-blue-900 dark:border-blue-400 dark:text-blue-200'
  }

  const widthClass = fullWidth ? 'w-full' : 'w-auto'

  const alertClasses = classNames(
    baseClasses,
    typeClasses[type],
    widthClass,
    className
  )

  return (
    <div className={alertClasses}>
      {icon && (
        <div className="mt-1">
          {icon}
        </div>
      )}

      <div>
        {title && <h5 className="text-lg font-semibold mb-2">{title}</h5>}
        <p className="text-base leading-relaxed">{message}</p>
      </div>
    </div>
  )
}

export default Alert